import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { HTMLAttributes } from "vue"
import { cn } from "@/lib/utils"


export default /*@__PURE__*/_defineComponent({
  __name: 'BreadcrumbItem',
  props: {
    class: { type: [Boolean, null, String, Object, Array] }
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(_unref(cn)('inline-flex items-center gap-1.5', props.class))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})